import React from "react";
import {
  Button,
  ScalableImage,
  Typography,
} from "design_system/src";

import { TSku } from "models/inventory/interfaces/sku.interface";
import { formatPrice } from "helpers/formatPrice";
import { prices } from "helpers/prices";
import { Link } from "react-router-dom";
import styles from "./VehicleItem.module.scss";

interface RecommendedSkuItemProps {
  sku: TSku;
}

const RecommendedSkuItem: React.FC<RecommendedSkuItemProps> = ({ sku }) => {
  return (
    <div className={styles.VehicleItem}>
      <div className="h_150_px m_b_sm">
        <ScalableImage
          className="img_cover br_md"
          src={sku.images[0]?.url}
          alt={`Moto ${sku.brandName} ${sku.modelName}, ${sku.cc}cc, año ${sku.year}`}
          desktopWidth={20}
          mobileWidth={50}
        />
      </div>

      <Typography weight="600" scale="small">Precio</Typography>
      <Typography weight="600" scale="small">${formatPrice(prices(sku.minPrice ?? 0), "")}</Typography>
      <Typography weight="400" scale="xxsmall" className="m_y_xs">{sku.brandName} {sku.modelName} {sku.cc}</Typography>

      <div className="w_100_per display_flex">
        <Link to={`/catalogo/${sku.code}`} className="w_100_per display_flex text_decoration_none">
          <Button scale="small" variant="outline" className="w_100_per br_md">
            Quiero esta moto
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default RecommendedSkuItem;
